import BreadCrumbs from "../../common/breadcrumbs";
import CS from "../../../services/commonService";
import Select from "react-select";
import React, { useState, useEffect } from "react";
import UploadAndCropImageModal from "../../common/UploadAndCropImageModal";
import dataUrlToFile from "../../common/urlToFile";
import { useFormik } from "formik";
import {
	useGetUserDataById,
	useUpdatePhoneNumber,
	useUpdateFullName,
} from "../../../queryHooks/useProfile";
import {
	mobileSchema,
	profileupdateSchema,
} from "../../../validations/profileValidations";
import { useStore } from "../../../zustand/store";

//	Component starts
const Profile = () => {
	const setLoading = useStore((state) => state.setLoading);
	const [countryCode, setCountryCode] = useState({ label: "+1", value: "+1" });
	//const [codeOptions, setCodeOptions] = useState([]);
	const [file, setFileData] = useState();
	const [userId, setUserId] = useState("");
	const [userData, setUserData] = useState();
	const { data: dataGetUserDataById, refetch } = useGetUserDataById(
		userData?.user_id
	);
	const [phone, setPhone] = useState("");
	const [newphoto, setNewPhoto] = useState();
	const [cropAndUploadImageModel, setCropAndUploadImageModel] = useState(false);

	const {
		mutateAsync: UpdatefullName,
		error: errorUpdatefullName,
		data: dataUpdatefullName,
	} = useUpdateFullName();

	//handle image cropped function
	const handleImageCropped = async (image) => {
		if (image) {
			const fileObj = dataUrlToFile(image);
			setFileData(fileObj);
			setNewPhoto(image);
		}
	};

	//close a model
	const closeModal = async () => {
		setCropAndUploadImageModel(false);
	};

	useEffect(() => {
		setNewPhoto(dataGetUserDataById?.data?.profile_image_url);
		const PhoneNumber = dataGetUserDataById?.data?.mobile;
		if (PhoneNumber) {
			const newPhone = PhoneNumber.substr(2, 12);
			setPhone(newPhone);
		}
	}, [dataGetUserDataById]);

	useEffect(() => {
		const user = JSON.parse(localStorage.getItem("userData"));
		setUserId(user.user_id);
		setUserData(user);
	}, [userId]);

	const { values, errors, handleChange, handleSubmit } = useFormik({
		initialValues: {
			firstName: dataGetUserDataById?.data?.first_name,
			lastName: dataGetUserDataById?.data?.last_name,
		},
		validationSchema: profileupdateSchema,
		enableReinitialize: true,
		onSubmit: (value) => {
			const newFormData = new FormData();
			newFormData.append("first_name", value.firstName);
			newFormData.append("last_name", value.lastName);

			newFormData.append("id", userId);

			if (file) {
				newFormData.append("profile_image", file);
			}

			UpdatefullName(newFormData);
		},
	});

	useEffect(() => {
		if (dataUpdatefullName) {
			setLoading(false);
			if (dataUpdatefullName.status === "success") {
				CS.showSuccessMessage(dataUpdatefullName.message);
				refetch();
			} else if (dataUpdatefullName.status === "fail") {
				CS.showErrorMessage(dataUpdatefullName.message);
			}
		}
	}, [dataUpdatefullName]);

	useEffect(() => {
		if (errorUpdatefullName) {
			setLoading(false);
			CS.showErrorMessage(errorUpdatefullName.response?.data?.message);
		}
	}, [errorUpdatefullName]);

	// const { data: countryData } = useCountryCodes();

	const {
		mutateAsync: UpdatePhoneNumber,
		error: errorUpdatePhoneNumber,
		data: dataUpdatePhoneNumber,
	} = useUpdatePhoneNumber();

	useEffect(() => {
		if (dataUpdatePhoneNumber) {
			setLoading(false);
			if (dataUpdatePhoneNumber.status === "success") {
				CS.showSuccessMessage(dataUpdatePhoneNumber.message);
				refetch();
			} else if (dataUpdatePhoneNumber.status === "fail") {
				CS.showErrorMessage(dataUpdatePhoneNumber.message);
			}
		}
	}, [dataUpdatePhoneNumber]);

	useEffect(() => {
		if (errorUpdatePhoneNumber) {
			setLoading(false);
			CS.showErrorMessage(errorUpdatePhoneNumber.response?.data?.message);
		}
	}, [errorUpdatePhoneNumber]);

	const {
		values: valuesPhone,
		errors: errorsPhone,
		handleChange: handleChangePhone,
		handleSubmit: handleSubmitPhone,
	} = useFormik({
		initialValues: {
			phone,
		},
		validationSchema: mobileSchema,
		enableReinitialize: true,
		onSubmit: (values) => {
			UpdatePhoneNumber({
				mobile: countryCode.label + values.phone,
				id: userId,
			});
		},
	});

	return (
		<>
			<div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
				<BreadCrumbs
					title="Admin Profile"
					data={[{ label: "Update Profile" }]}
				/>
			</div>
			<div className="card profile-card mb-5">
				<div className="align-items-center">
					<div className="mt-3">
						<form onSubmit={(e) => handleSubmit(e)}>
							<div className="row">
								<div className="col-md-2 mb-3">
									<div className="edit-image ml-0">
										<div className="user-image">
											<div>
												<div onClick={() => setCropAndUploadImageModel(true)}>
													{CS.renderImageUrl(newphoto, "admin", true)}
												</div>
											</div>
											<label
												className="img-upload"
												htmlFor="attach-file"
												onClick={() => setCropAndUploadImageModel(true)}
											>
												<em className="bx bxs-edit-alt" />
											</label>
											<UploadAndCropImageModal
												show={cropAndUploadImageModel}
												handleImageCropped={handleImageCropped}
												handleClose={closeModal}
											/>
										</div>
									</div>
								</div>
								{/* image end */}
								{/* first name start */}
								<div className="form-group col-md-5 mb-md-4 mb-3">
									<label className="mb-1" htmlFor="firstName">
										First Name<sup className="text-danger">*</sup>
									</label>
									<div className="w-100">
										<input
											type="text"
											className="form-control"
											id="firstName"
											name="firstName"
											placeholder="Enter First Name"
											value={values.firstName}
											onChange={handleChange}
										/>
										<span className="text-danger d-block mt-2">
											{errors.firstName}
										</span>
									</div>
								</div>

								{/* first name end */}

								{/* last name start */}
								<div className="form-group col-md-5 mb-md-4 mb-3">
									<label className="mb-1" htmlFor="lastName">
										Last Name<sup className="text-danger">*</sup>
									</label>
									<div className="w-100">
										<input
											type="text"
											className="form-control"
											id="lastName"
											name="lastName"
											placeholder=" Enter Last Name"
											value={values.lastName}
											onChange={handleChange}
										/>
										<span className="text-danger d-block mt-2">
											{errors.lastName}
										</span>
									</div>
								</div>
								{/* last name end */}
							</div>

							<div className="btn-blocks text-right mb-2">
								<button type="submit" className="btn btn-primary glow-primary">
									Update
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div className="card profile-card mb-5">
				<div className="row align-items-center">
					<div className="col-md-12 mt-3">
						<form
							onSubmit={(e) => {
								handleSubmitPhone(e);
							}}
						>
							<div>
								<div className="row">
									<div className="form-group col-md-6 mb-md-4 mb-3">
										<label className="mb-1" htmlFor="emailId">
											Email<sup className="text-danger">*</sup>
										</label>
										<div className="w-100">
											<input
												className="form-control"
												id="emailId"
												name="emailId"
												type="email"
												value={dataGetUserDataById?.data?.email}
												readOnly
												style={{ backgroundColor: "lightgray", color: "#000" }}
											/>
										</div>
									</div>
									<div className="form-group col-md-6 mb-md-4 mb-3">
										<div className="row justify-content-center">
											<div className="col-md-3">
												<label className="mb-1" htmlFor="phonelId">
													Country Code<sup className="text-danger">*</sup>
												</label>
												<Select
													className="default-select"
													value={countryCode}
													// options={codeOptions}
													isDisabled="true"
													onChange={(val) => setCountryCode(val)}
												></Select>
											</div>
											<div className="col-md-9">
												<label className="mb-1" htmlFor="phonelId">
													Phone Number<sup className="text-danger">*</sup>
												</label>
												<input
													className="form-control"
													type="number"
													value={valuesPhone.phone}
													onChange={handleChangePhone}
													id={"phone"}
													name={"phone"}
													onInput={(e) =>
														(e.target.value = e.target.value.slice(0, 10))
													}
												/>
												<span className="text-danger d-block">
													{errorsPhone.phone ? errorsPhone.phone : null}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="btn-blocks text-right mb-2">
								<button type="submit" className="btn btn-primary glow-primary">
									Update
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default Profile;
